// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__EUB6S","modal":"Modal_modal__1r7WA","slide-down":"Modal_slide-down__rQreE"};